<template>
  <div>
    <div class="ListingGrid-loading text-primary flex justify-center" v-show="isPending">
      <i class="fal fa-spinner-third fa-spin"></i>
    </div>
    <div class="ListingGrid mt-12">
      <ArtistStudioPost :post="data" v-if="!isPending" />
    </div>
  </div>
</template>

<script setup>
import Http from "@/lib/Http"
import ArtistStudioPost from "@/pages/ArtistProfilePage/ArtistStudioPost.vue"
import { useQuery } from "@tanstack/vue-query"
import { inject } from "vue"

const { slug } = defineProps({
  slug: String,
})

const artist = inject("artist")

const { data, isPending } = useQuery({
  queryKey: [`studioPost${artist.id}${slug}`],
  queryFn: async () => (await Http.get(`/api/artists/${artist.id}/studio_posts/${slug}`))?.data?.studio_post,
  refetchOnWindowFocus: false,
})
</script>
